import { Typography, withStyles } from '@material-ui/core';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import React from 'react'
const styles = (theme) => {
    console.log("GameInfoExp Theme: ", theme);
    const data = {
        root: {
            margin: 0,
            padding: theme.spacing(2),
            background: "#343a40",
            "& > * + *": {
                marginTop: theme.spacing(2),
            },
        },
        closeButton: {
            position: "absolute",
            right: theme.spacing(1),
            top: theme.spacing(1.2),
            color: theme.palette.grey[500],
        },
    };
    return data;
};
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    console.log("DialogueTitle:::::");
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

export default DialogTitle
